import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/withStyles';
import 'react-dates/initialize';
import { injectIntl } from 'react-intl';
import { DateRangePicker } from 'react-dates';
import { setPersonalizedValues } from '../../../actions/personalized';
import { dateFormat } from '../../../config';
import messages from '../../../locale/jsonMessages';
import { dateInternationalization, isRTL } from '../../../helpers/formatLocale';
import { change } from 'redux-form';

import s from 'react-dates/lib/css/_datepicker.css';
import t from '../../../styles/reactDatesCalendar.css';

const DateRange = ({
  numberOfMonths,
  setPersonalizedValues,
  personalized,
  intl: { formatMessage },
  locale,
  formName,
  change
}) => {
  const [focusedInput, setFocusedInput] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (personalized?.startDate && personalized?.endDate) {
      setStartDate(moment(personalized.startDate));
      setEndDate(moment(personalized.endDate));
    }
  }, [personalized, locale]);

  const onDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);

    if (startDate && endDate) {
      setPersonalizedValues({ name: 'startDate', value: moment(startDate).format('YYYY-MM-DD') });
      setPersonalizedValues({ name: 'endDate', value: moment(endDate).format('YYYY-MM-DD') });
    }
  };

  const onClear = () => {
    setPersonalizedValues({ name: 'startDate', value: null });
    setPersonalizedValues({ name: 'endDate', value: null });
    change(formName, 'dates', null);
    setStartDate(null);
    setEndDate(null);
  };
  dateInternationalization(locale);

  return (
    <div>
      <DateRangePicker
        displayFormat={dateFormat?.shortDateFormat}
        onDatesChange={onDatesChange}
        onFocusChange={setFocusedInput}
        focusedInput={focusedInput}
        startDate={startDate}
        endDate={endDate}
        numberOfMonths={numberOfMonths}
        startDatePlaceholderText={formatMessage(messages.checkIn)}
        endDatePlaceholderText={formatMessage(messages.checkOut)}
        hideKeyboardShortcutsPanel
        readOnly
        minimumNights={0}
        anchorDirection={isRTL(locale) ? 'right' : 'left'}
        isRTL={isRTL(locale)}
        renderCalendarInfo={() => (
          <div onClick={onClear} className={'clearFlex'}>
            {formatMessage(messages.clear)}
          </div>
        )}
      />
    </div>
  );
};

DateRange.propTypes = {
  onChange: PropTypes.any,
  numberOfMonths: PropTypes.number,
  setPersonalizedValues: PropTypes.func.isRequired,
  formatMessage: PropTypes.any,
  personalized: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  locale: PropTypes.string,
  intl: PropTypes.object,
  formName: PropTypes.string,
  change: PropTypes.func.isRequired
};

const mapState = state => ({
  personalized: state.personalized,
  locale: state.intl.locale
});

const mapDispatch = {
  setPersonalizedValues,
  change
};

export default injectIntl(withStyles(s, t)(connect(mapState, mapDispatch)(DateRange)));
